import GlobalDataStorageFactory from '../factories/GlobalDataStorageFactory';
import type GetGlobalDataResult from '../models/GetGlobalDataResult';

export default class GlobalDataStorage {
    private constructor() {}

    public static store(model: GetGlobalDataResult) {
        const useCase = GlobalDataStorageFactory.makeStore();
        return useCase.invoke(model);
    }

    public static markedAsCanFetch() {
        const useCase = GlobalDataStorageFactory.makeMarkedAsCanFetchUseCase();
        return useCase.invoke();
    }

    public static markedAsFetchError() {
        const useCase = GlobalDataStorageFactory.makeMarkedAsFetchErrorUseCase();
        return useCase.invoke();
    }
}
